import { DateRangePicker } from "rsuite";
import "rsuite/DateRangePicker/styles/index.css";
import "./DatePicker.css";
import { ReactComponent as Calendar } from "../../../resources/icons/calendar.svg";
import { useState } from "react";
import { FormFilter } from "../../../core/models/FormFilter";
import { DateRange } from "rsuite/DateRangePicker";
import { addDays, subDays } from "rsuite/esm/utils/dateUtils";

export interface Props {
    id?: string;
    onChange: (period?: FormFilter["period"]) => void;
    value: FormFilter["period"];
}

export function FstyrDateRangePicker({ id, onChange, value }: Props) {
    const [open, setOpen] = useState<boolean>(false);
    const months = [
        "Januar",
        "Februar",
        "Marts",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "December"
    ];

    const dr = value ? ([value?.start, value?.end] as DateRange) : null;
    return (
        <DateRangePicker
            id={id}
            className={`fstyr-date-range-picker ${open && "open-picker"}`}
            ranges={[
                {
                    label: "I dag",
                    value: [new Date(), new Date()]
                },
                {
                    label: "I går",
                    value: [addDays(new Date(), -1), addDays(new Date(), -1)]
                },
                {
                    label: "Sidste 7 dage",
                    value: [subDays(new Date(), 6), new Date()]
                },
                {
                    label: "Sidste 30 dage",
                    value: [subDays(new Date(), 29), new Date()]
                }
            ]}
            value={dr}
            caretAs={() => <Calendar />}
            isoWeek
            onChange={(value) => {
                onChange(
                    value ? { start: value[0], end: value[1] } : undefined
                );
            }}
            renderTitle={(date) =>
                `${months[date.getMonth()]} ${date.getFullYear()}`
            }
            character=" - "
            showHeader={false}
            format="dd-MM-yyyy"
            placeholder="Vælg periode"
            editable={false}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            locale={{
                monday: "M",
                tuesday: "T",
                wednesday: "O",
                thursday: "T",
                friday: "F",
                saturday: "L",
                sunday: "S"
            }}
        />
    );
}
